import { BLACK_100, BLACK_400, BLACK_500, BLACK_900, BLUE_500 } from '../colors';
var breadcrumbConfig = {
  maxDisplayedItems: 4,
  overflowIndex: 2,
  data: [],
  config: {
    activeColor: BLACK_900,
    inactiveColor: BLUE_500,
    disabledColor: BLACK_500,
    iconColor: BLACK_400
  }
};
var breadcrumbConfigDark = Object.assign(Object.assign({}, breadcrumbConfig), {
  config: Object.assign(Object.assign({}, breadcrumbConfig.config), {
    activeColor: BLACK_100
  })
});
export default {
  light: breadcrumbConfig,
  dark: breadcrumbConfigDark,
  white: breadcrumbConfig
};